import React, { ElementType } from 'react'
import { ButtonProps } from './types'
import { Text } from '../text'
import { buttonStyles } from './styles'
import { Icon } from '../icon'

export const Button = <T extends ElementType = 'button'>({
  as,
  variant = 'solid',
  theme = 'background_is_darker',
  // This is used to override the theme when using styled-components cause theme is a reserved prop
  themeOverride = 'background_is_darker',
  leadingIcon,
  leadingIconConfig,
  trailingIcon,
  trailingIconConfig,
  gap = 'l',
  children,
  className,
  style,
  animation,
  ...rest
}: ButtonProps<T>) => {
  const Component = as || 'button'
  return (
    <Component
      css={buttonStyles(variant, themeOverride || theme, (animation && trailingIcon !== undefined) ?? false, gap)}
      className={className}
      style={style}
      {...rest}
    >
      {leadingIcon && <Icon kind={leadingIcon} {...leadingIconConfig} />}
      {typeof children === 'string' ? (
        <Text fontStyle="label-m" as="span">
          {children}
        </Text>
      ) : (
        children
      )}
      {trailingIcon && <Icon kind={trailingIcon} {...trailingIconConfig} />}
    </Component>
  )
}

Button.displayName = 'Button'
